import React from 'react'
import Background from './Background'

import TopBar from './TopBar'
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'
import Privacy from './Privacy'

import { Space } from 'antd'

// TopBar is the house bar (standard, part 3) and spans the page, outside the column.
// SiteHeader is this game's own hero — the heading, the tagline and the rules — and lives
// inside the column with everything else.
const SiteWrapper = ({ children }) => {
  return (
    <Background top={<TopBar />}>
      <Space direction='vertical' size='large'>

        <SiteHeader />

        {children}

        <Privacy />

        <SiteFooter />

      </Space>
    </Background>
  )
}

export default SiteWrapper
